import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../../../src/environments/env';

@Injectable({
  providedIn: 'root'
})
export class HelpdeskService {


  constructor(private http:HttpClient) { }

  private apiUrl = environment.BASE_URL+`/ptp/`;
  public header = { headers: {'Access-Control-Allow-Origin':'*'} }

  public fetchhelpData(page:any,size:any,filterString: any): Observable<any[]> {
    return this.http.get<any[]> (this.apiUrl + `api/admin/help-desk?page=`+ page + `&size=` + size + filterString, this.header);
  }

  // admin/help-desk/10/status?status=Closed

  public updateHelpDeskStatus(id:any,status:any){
     return this.http.put<any[]> (this.apiUrl + `api/admin/help-desk/`+id+'/status?status='+status, this.header);
  }

  public editStatus(id:any, payload: any): Observable<any[]> {
    return this.http.put<any[]> (this.apiUrl + `api/admin/user/`+id+'/status/enroll', payload, this.header);
  }

  public editRenewalStatus(id:any, payload: any): Observable<any[]> {
    return this.http.put<any[]> (this.apiUrl + `api/admin/user/`+id+'/status/renewal', payload, this.header);
  }

  public editReinstateStatus(id:any, payload: any): Observable<any[]> {
    return this.http.put<any[]> (this.apiUrl + `api/admin/user/`+id+'/status/expired', payload, this.header);
  }

  public editExpiredStatus(id:any, status:any,remarks:any,dateOfSubmission:any): Observable<any[]> {
    return this.http.put<any[]> (this.apiUrl + `api/admin/user/`+id+'/status/expired?status='+status+'&remarks='+remarks+'&mctRenewalApprovedDate='+dateOfSubmission, this.header);
  }

   public sendEmail(payload:any): Observable<any[]> {
    //return this.http.post<any[]> (environment.MAIL_URL, payload,{ headers: {'Content-Type': 'application/json','user': environment.MAIL_USER,'Authorization':'Basic ' + environment.AUTH_TOKEN}});
    return this.http.post<any[]>(this.apiUrl + `api/spp/email/trigger`, payload, this.header);
  }

  public sendEmailUser(payload:any): Observable<any[]> {
    //return this.http.post<any[]> (environment.MAIL_URL, payload,{ headers: {'Content-Type': 'application/json','user': environment.MAIL_USER,'Authorization':'Basic ' + environment.AUTH_TOKEN}});
    return this.http.post<any[]>(this.apiUrl + `api/spp/email/trigger`, payload, this.header);
  }
  
  public downloadFile(): Observable<any[]> {
    return this.http.get<any[]> (this.apiUrl +`api/admin/help-desk/download-csv`);
  }
}
